module.exports = __webpack_public_path__ + "img/depmap_svg_V108.b1522af4.svg";